import { ERROR_ACTION, WAIT_FOR_ACTION } from "redux-wait-for-action";

export const actionTypes = {
    AUDITS_CREATE_INIT: "AUDITS_CREATE_INIT",
    AUDITS_CREATE_SUMMARY: "AUDITS_CREATE_SUMMARY",
    AUDITS_CREATE_UPDATE: "AUDITS_CREATE_UPDATE",

    AUDITS_CREATE_SAVE_FAILURE: "AUDITS_CREATE_SAVE_FAILURE",
    AUDITS_CREATE_SAVE_REQUEST: "AUDITS_CREATE_SAVE_REQUEST",
    AUDITS_CREATE_SAVE_SUCCESS: "AUDITS_CREATE_SAVE_SUCCESS",

    AUDIT_CREATE_ITEM_CLEAR: "AUDIT_CREATE_ITEM_CLEAR",
    AUDIT_CREATE_ITEM_SET: "AUDIT_CREATE_ITEM_SET",
    AUDIT_CREATE_ITEM_UPDATE: "AUDIT_CREATE_ITEM_UPDATE",

    AUDIT_LOCATIONS_GET_COUNT_REQUEST: "AUDIT_LOCATIONS_GET_COUNT_REQUEST",
    AUDIT_LOCATIONS_GET_COUNT_SUCCESS: "AUDIT_LOCATIONS_GET_COUNT_SUCCESS",
    AUDIT_LOCATIONS_GET_COUNT_FAILURE: "AUDIT_LOCATIONS_GET_COUNT_FAILURE",

    AUDIT_CREATE_CLEAR_VALUES: "AUDIT_CREATE_CLEAR_VALUES"
};

export const actionCreators = {
    // storing intermidiate audit results
    itemSet: (item: any) => ({
        type: actionTypes.AUDIT_CREATE_ITEM_SET,
        payload: { item }
    }),
    itemUpdate: (item: any) => ({
        type: actionTypes.AUDIT_CREATE_ITEM_UPDATE,
        payload: { item }
    }),
    itemClear: (item: any) => ({
        type: actionTypes.AUDIT_CREATE_ITEM_CLEAR
    }),
    clearReducer: () => ({
        type: actionTypes.AUDIT_CREATE_CLEAR_VALUES
    }),
    // unknown yet to discover
    init: () => ({
        type: actionTypes.AUDITS_CREATE_INIT
    }),
    summary: () => ({
        type: actionTypes.AUDITS_CREATE_SUMMARY
    }),
    update: (auditsCreate: any) => ({
        type: actionTypes.AUDITS_CREATE_UPDATE,
        payload: { ...auditsCreate }
    }),

    saveRequest: () => ({
        type: actionTypes.AUDITS_CREATE_SAVE_REQUEST,
        [WAIT_FOR_ACTION]: actionTypes.AUDITS_CREATE_SAVE_SUCCESS,
        [ERROR_ACTION]: actionTypes.AUDITS_CREATE_SAVE_FAILURE
    }),
    saveSuccess: (audits: Array<any>) => ({
        type: actionTypes.AUDITS_CREATE_SAVE_SUCCESS,
        payload: { audits }
    }),
    saveFailure: (error: Error) => ({
        type: actionTypes.AUDITS_CREATE_SAVE_FAILURE,
        error
    }),
    getCountRequest: (branchLocation: Array<any>) => ({
        type: actionTypes.AUDIT_LOCATIONS_GET_COUNT_REQUEST,
        [WAIT_FOR_ACTION]: actionTypes.AUDIT_LOCATIONS_GET_COUNT_SUCCESS,
        [ERROR_ACTION]: actionTypes.AUDIT_LOCATIONS_GET_COUNT_FAILURE,
        payload: { branchLocation }
    }),
    getCountSuccess: (locCount: Array<any>) => ({
        type: actionTypes.AUDIT_LOCATIONS_GET_COUNT_SUCCESS,
        payload: { locCount }
    }),
    getCountFailure: (error: Error) => ({
        type: actionTypes.AUDIT_LOCATIONS_GET_COUNT_FAILURE,
        error
    })
};

export default {
    create: actionCreators,
    type: actionTypes
};
